const i18nTranslate = (...args: string[]): string => {
  const { $i18n } = useNuxtApp()
  return $i18n.t(args[0], args.slice(1))
}

export { i18nTranslate }
